import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as styled from './styles';
import { BlobThree } from '../vector';
import SocialLink from '../SocialLink';
import { Link } from 'gatsby';
import { SOCIAL_MEDIA_LIST } from '../../constants/socialMediaList';

const SocialMediaSimpleListing = ({
  heading,
  colorTheme = 'blue',
}) => {
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await fetch('https://mhs-staging.netlify.app/.netlify/functions/instaFeed', {
          method: 'POST',
        });
        const data = await res.json();
        setResponseData(data.data.slice(0, 6));
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const Card = ({ item }) => {
    return <Link to={item.permalink} target='_blank' title={item.caption || 'Instagram post'}>
      <styled.Item>
        <styled.Image
          src={item.media_url}
          alt={item.caption || 'Instagram post'}
          loading='lazy'
        />
      </styled.Item>
    </Link>;
  };

  return (
    <styled.Wrapper>
      <BlobThree />
      <styled.Inner>
        <styled.HeadingContainer>
          <styled.SocialList>
            {SOCIAL_MEDIA_LIST.map((link) => (
              <SocialLink key={link.title} {...link} colorTheme={colorTheme} />
            ))}
          </styled.SocialList>
          <styled.Heading level={200} colorTheme={colorTheme}>
            {heading}
          </styled.Heading>
        </styled.HeadingContainer>
        <styled.Items>
          {!loading ? responseData?.map((item, index) => (
            <Card item={item} key={index} />
          )) : null}
        </styled.Items>
      </styled.Inner>
    </styled.Wrapper>
  );
};

// Prop validation
SocialMediaSimpleListing.propTypes = {
  heading: PropTypes.string.isRequired,
  colorTheme: PropTypes.oneOf(['blue', 'green', 'orange', 'purple', 'yellow']),
  socialMediaList: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
  })),
};

// Default props for optional values
SocialMediaSimpleListing.defaultProps = {
  colorTheme: 'blue',
};

export default SocialMediaSimpleListing;
